<template>
  <div>
    <z-centralized-toolbar>
      <v-toolbar-title>Perfil do Usuário</v-toolbar-title>

    </z-centralized-toolbar>
    <z-container class="py-6">
      <!-- <h3 class="text-body-1 mb-3">{{$store.state.titulo_tela}}</h3> -->

      <v-form>
        <v-card class="mb-4">
          <v-card-title class="d-block text-h6">
            <div class="text-h6">
              Identificação
            </div>
            <div class="text-body-2">Atualize as informações de perfil e endereço de e-mail da sua conta.</div>
          </v-card-title>
          <v-card-text class="pa-4">

            <v-row dense>
              <v-col cols="6">

                <v-row dense>
                  <v-col cols="12">
                    <z-text-field
                      v-model="usuario.name"
                      name="nome" 
                      label="Nome" 
                      id="nome"
                    ></z-text-field>
                  </v-col>

                  <v-col cols="12">
                    <z-text-field
                      v-model="usuario.email"
                      name="email"
                      label="Login"
                      id="email"
                      disabled
                      dense
                    ></z-text-field>
                  </v-col>

                  <v-col cols="12">
                    <z-text-field
                      v-model="usuario.perfil.descricao"
                      name="perfil"
                      label="Perfil"
                      id="perfil"
                      disabled
                      dense
                    ></z-text-field>
                  </v-col>

                  <!-- <v-col cols="12">
                    <z-text-field v-mask="$globals.CELULAR_MASK" name="whatsapp" label="Whatsapp" id="whatsapp"
                      dense></z-text-field>
                  </v-col> -->
                </v-row>

              </v-col>
            </v-row>

          </v-card-text>
          <v-card-actions class="pa-4 pt-0">
            <v-btn color="primary" depressed @click="salvarPerfil" :loading="loading">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>

      <v-form>
        <v-card>
          <v-card-title class="d-block text-h6">
            <div class="text-h6">
              Mudar Senha
            </div>
            <div class="text-body-2">Certifique-se de que sua conta esteja usando uma senha longa e aleatória para
              permanecer segura.</div>
          </v-card-title>
          <v-card-text class="pa-4">
            <v-row dense>
              <v-col sm="6">

                <v-row dense>
                  <v-col cols="12">
                    <z-text-field name="password" label="Senha Atual" id="password" dense></z-text-field>
                  </v-col>
                  <v-col cols="12">
                    <z-text-field name="new_password" label="Nova Senha" id="new_password" dense></z-text-field>
                  </v-col>
                  <v-col cols="12">
                    <z-text-field name="confirm_password" label="Confirmar Nova Senha" id="confirm_password"
                      dense></z-text-field>
                  </v-col>
                </v-row>

              </v-col>
            </v-row>

          </v-card-text>
          <v-card-actions class="pa-4 pt-0">
            <v-btn color="primary" depressed>Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </z-container>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
export default {
  name: 'UsuariosProfile',

  data() {
    return {
      loading: false,
      logged_user: {}
    }
  },

  computed: {
    usuario() {
      return this.$store.state.usuarios.usuario;
    }
  },

  mounted() {
    this.setTitulo('Perfil do Usuário');
    this.getUser();
  },

  methods: {
    ...mapActions('usuarios', ['abrir', 'salvarPerfilUsuario']),
    ...mapMutations(['setTitulo', 'SET_USUARIO']),

    async getUser() {
      this.logged_user = this.$auth.getUser();
      await this.abrir(this.logged_user.id);
    },

    async salvarPerfil() {
      try {
        this.loading = true;
        await this.salvarPerfilUsuario({
          id: this.usuario.id,
          name: this.usuario.name
        });

        this.$eventbus.notificar('Perfil salvo com sucesso.');

        this.logged_user.name = this.usuario.name;
        this.$auth.setUserData(this.logged_user);
        this.SET_USUARIO(this.logged_user);
      } catch (error) {
        this.$eventbus.notificar('Houve um problema ao salvar o perfil');
      } finally {
        this.loading = false;
      }
    }
  },
}

</script>

<style lang="scss" scoped></style>